export const emptyForm = {
  recipients: [{ type: 'users', recipient: 'all' }],
  date: '',
  time: '',
  title: '',
  body: ''
}

export type Notification = {
    id?: string;
    title: string;
    body: string;
    sent_at?: null | string;
    recipients: {
      recipient: string;
      type: string;
    }[];
    start: Date;
    end?: Date;
}

export const monthsTranslationConverter = (date: string) => {
  const months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december']
  const index = Number(date.substr(5, 2).replace(/^0+/, '')) - 1
  return months[index]
}
